export const authConstants = {
    LOGIN_REQUEST: 'auth:login_request',
    LOGIN_SUCCESS: 'auth:login_success',
    LOGIN_FAILURE: 'auth:login_failure',

    AUTH_LOGOUT: 'auth:logout',

    REGISTRATION_REQUEST: 'auth:registration_request',
    REGISTRATION_SUCCESS: 'auth:registration_success',
    REGISTRATION_FAILURE: 'auth:registration_failure',

    ALL_REQUEST: 'auth:all_request',
    ALL_SUCCESS: 'auth:all_success',
    ALL_FAILURE: 'auth:all_failure',
    DESTROY_SESSION: 'destroy_session',

};

